// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"62d24d1d","740":"3baf0951"}[chunkId] + ".chunk.css";
};